import React from 'react';
import p from '../../styles/renewal/OnePage.module.css';

const About = () => (
  <section className={`${p.aboutGrid} ${p.reveal}`}>
    <div className={`${p.cardLift} ${p.aboutCard}`}>
      <div className={p.aboutEyebrow}>OFFERGROUP BNPL</div>
      <h2 className={p.titleMd}>
        사업자의 결제 부담을 고려한
        <br />
        오퍼그룹 BNPL
      </h2>
      <p className={p.aboutText}>
        필요한 금액과 상황을 알려주시면 거래내용을 확인한 후 이용 가능한 방식과 조건을 안내해
        드립니다.
      </p>
      <div className={p.aboutNote}>
        상품이나 이용방식을 미리 결정하지 않아도 상담할 수 있습니다.
      </div>
    </div>

    <div className={p.aboutStack}>
      <div className={p.aboutStackBg} aria-hidden="true" />
      <div className={p.aboutDark}>
        <div className={p.aboutDarkEyebrow}>OFFERGROUP BNPL</div>
        <div className={p.aboutDarkLead}>이용방식을 미리 정하지 않아도</div>
        <div className={p.aboutDarkBig}>
          상황에 맞는
          <br />
          방식과
          <br />
          조건을 안내
        </div>
        <div className={p.aboutRule} />
        <p className={p.aboutDarkText}>
          상담을 통해 가능 여부와 조건을 확인한 후 최종적으로 결정할 수 있습니다.
        </p>
      </div>
    </div>
  </section>
);

export default About;
